var _path, _path2, _path3, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V14C0 15.1046 0.895431 16 2 16H18C19.1046 16 20 15.1046 20 14V2C20 0.895431 19.1046 0 18 0H2ZM13.1142 6.85719L11.1428 4.88574L6.42493 9.60794C5.99518 10.0377 5.67761 10.5665 5.50016 11.1477L5.00784 12.7605C4.96596 12.8977 5.0989 13.0349 5.23934 12.992L6.85217 12.4996C7.43332 12.3222 7.96198 12.0047 8.39165 11.575L13.1142 6.85719ZM14.7558 4.03225L13.9678 3.24412C13.6422 2.91863 13.1145 2.91862 12.789 3.24409L11.9499 4.08572L13.9143 6.05004L14.8131 5.14773C15.0801 4.82034 15.061 4.3374 14.7558 4.03225Z",
    fill: "url(#paint0_linear_6314_84578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20C3.94772 20 3.5 19.5523 3.5 19L3.5 17L5.5 17L5.5 19C5.5 19.5523 5.05228 20 4.5 20Z",
    fill: "#99A2AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C15.4477 20 15 19.5523 15 19L15 17L17 17L17 19C17 19.5523 16.5523 20 16 20Z",
    fill: "#99A2AD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 10,
    height: 1,
    fill: "#99A2AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6314_84578",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesDesk);
export default __webpack_public_path__ + "static/media/advantages_desk.392ded88f1e2169cee69cf9851f6161b.svg";
export { ForwardRef as ReactComponent };